import type { IErrorOperationResult } from '../types';
import type { CreateErrorOperationResultOptions } from './create-error-operation-result.types';

export function createErrorOperationResult<TError extends string>(
  options: CreateErrorOperationResultOptions<TError>,
): IErrorOperationResult<TError> {
  return {
    success: false,
    errors: options.errors,
  };
}
